import store from "@/store";
import { hasPerm } from "./btnPermission";
import Loading from "@/components/loading/index.vue";

const directives = {
  install: (app) => {
    // 按钮权限
    app.directive('auth', {
      mounted(el, binding) {
        if (!hasPerm(binding.value, binding.arg)) {
          el.parentNode.removeChild(el);
        }
      }
    });
    // 自定义指令 v-loading
    // app.directive('sloading', {
    //   mounted(el, binding) {
    //     const div = document.createElement('div');
    //     div.style.position = 'absolute';
    //     div.style.top = '0';
    //     div.style.left = '0';
    //     div.style.width = '100%';
    //     div.style.height = '100%';
    //     div.style.display = 'flex';
    //     div.style.justifyContent = 'center';
    //     div.style.alignItems = 'center';
    //     div.style.background = 'rgba(255, 255, 255, 0.7)';

    //     const spinner = document.createElement('div');
    //     spinner.style.border = '4px solid #f3f3f3';
    //     spinner.style.borderTop = '4px solid #3498db';
    //     spinner.style.borderRadius = '50%';
    //     spinner.style.width = '40px';
    //     spinner.style.height = '40px';
    //     spinner.style.animation = 'spin 2s linear infinite';
    //     spinner.style.padding = '10px';

    //     div.appendChild(spinner);

    //     if (binding.value) {
    //       el.appendChild(div);
    //     }
    //   },
    //   updated(el, binding) {
    //     if (binding.value) {
    //       el.style.overflow = 'hidden';
    //       const loader = el.querySelector('.loader');
    //       if (!loader) {
    //         const div = document.createElement('div');
    //         div.className = 'loader';
    //         el.appendChild(div);
    //       }
    //     } else {
    //       el.style.overflow = 'visible';
    //       const loader = el.querySelector('.loader');
    //       if (loader) {
    //         el.removeChild(loader);
    //       }
    //     }
    //   }
    // });
    // 更改颜色   一般就是用这种简化形式就足够了
    // 这种简化形式的写法会在钩子函数'mounted'和'updated'中调用
    app.directive("selfcolor", (el, binding) => {
      el.style.color = binding.value;
    });
    // 点击按钮一键复制
    app.directive("selfCopy", (el, binding) => {
      el.onclick = () => {
        console.log(binding.value);
        if (!binding.value) {
          alert("不能复制空文本");
          return false;
        }
        navigator.clipboard.writeText(binding.value);
        alert("复制成功");
      };
    });
    // 对象字面量  指令可以接受任何合法的javascript表达式
    app.directive("objectParams", (el, binding) => {
      console.log(binding.value);
      console.log(binding.arg);
    });
    //数组
    app.directive("arrayParams", (el, binding) => {
      console.log(binding.value[1]);
    });
    // 测试所有生命周期
    app.directive("testLifeCycle", {
      // 在绑定元素的 attribute 前
      // 或事件监听器应用前调用
      created(el, binding, vnode, prevVnode) {
        // 下面会介绍各个参数的细节
      },
      // 在元素被插入到 DOM 前调用
      beforeMount(el, binding, vnode, prevVnode) { },
      // 在绑定元素的父组件
      // 及他自己的所有子节点都挂载完成后调用
      mounted(el, binding, vnode, prevVnode) {
        console.log(binding);
        console.log(binding.modifiers);
        if (Object.keys(binding.modifiers).length == 0) {
          alert("说明没有传修饰符");
          return false;
        }
        alert("说明传了修饰符");
      },
      // 绑定元素的父组件更新前调用
      beforeUpdate(el, binding, vnode, prevVnode) { },
      // 在绑定元素的父组件
      // 及他自己的所有子节点都更新后调用
      updated(el, binding, vnode, prevVnode) { },
      // 绑定元素的父组件卸载前调用
      beforeUnmount(el, binding, vnode, prevVnode) { },
      // 绑定元素的父组件卸载后调用
      unmounted(el, binding, vnode, prevVnode) { },
    });
  },
};
export default directives;
